import React from 'react';
import sendClientSideError from './accessors/ClientSideErrorAccessor';

interface Window {
    location: Location;
}

interface Location {
    href: string;
}

declare var window: Window;

interface ErrorBoundaryProps {
    href?: string;
    text?: string;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: any;
    errorInfo: any;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {

    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null, 
            errorInfo: null 
        }
    }

    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    
    componentDidCatch(error: any, errorInfo: any) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        })

        // Log the error to PYO service
        sendClientSideError(window.location.href, error.toString(), errorInfo.componentStack);
    }

    render() {
        if (this.state.hasError) {
            const href = this.props.href || '/your-orders';
            const text = this.props.text || 'Go to your orders';

            return (
                <pui-section pageContainer paddingTop="extra-large" secondaryAxisArrangement="center">
                    <arc-alert size="banner" type="error">
                        <span slot="title">Something went wrong while loading this page</span>
                        <span slot="message">Please try again later.</span>
                        <div slot="actions">
                            <a href={href}>
                                <arc-button size="large" type="link">{text}</arc-button>
                            </a>
                        </div>
                    </arc-alert>
                </pui-section>
            );
        }

        return this.props.children; 
    }
}